import { ProductPageLayout } from '../components/ProductPageLayout';

export function SpeedrampWorkflowPage() {
    return <ProductPageLayout productId="speedramp-workflow" />;
}
